module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("学导跟进数据")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学导申请加课时记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 16,
      "md": 10
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "label-width": 75
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "userNickname"
    },
    model: {
      value: (_vm.queryParam.userNickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userNickname", $$v)
      },
      expression: "queryParam.userNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 4
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookCourseChange/listAddCourseDetail",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e9f5a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/ShowAddCourseDetail.vue
// module id = 1898
// module chunks = 8